import { SURVEY_LIST,SURVEY_RESPONSE_DATA } from "SurveyAction";

export function surveyList(state = {}, action) {
  switch (action.type) {
    case SURVEY_LIST:
      return action.payload;
    default:
      return state;
  }
}

/****  Survey response display and download.  ****/
export function surveyResponseData(state = {}, action) {
  switch (action.type) {
    case SURVEY_RESPONSE_DATA:
      return action.payload;
    default:
      return state;
  }
}
